module.exports = __webpack_public_path__ + "img/qr_code.6b33ad04.jpg";